export const BLOCK_TYPES = [
    'header',
    'hero',
    'text',
    'imageText',
    'featureGrid',
    'stats',
    'steps',
    'quote',
    'banner',
    'gallery',
    'pricing',
    'testimonials',
    'menuList',
    'openingHours',
    'contact',
    'mapAddress',
    'faq',
    'cta',
    'socialLinks',
    'footer',
    'spacer',
    'designed'
];
export const blockDefaults = {
    header: {
        brand: 'Signal & Grain',
        nav: [
            { label: 'Home', href: '#top' },
            { label: 'About', href: '#about' },
            { label: 'Contact', href: '#contact' }
        ],
        cta: { label: 'Book now', href: '#contact' }
    },
    hero: {
        eyebrow: 'Welcome',
        title: 'Make something worth looking at',
        lead: 'A calm, confident website for your Guernsey business.',
        primaryCta: { label: 'Get started', href: '#contact' },
        secondaryCta: { label: 'Learn more', href: '#about' },
        image: { assetId: null, alt: '' }
    },
    text: {
        heading: 'A clear heading',
        body: [
            {
                kind: 'p',
                children: [
                    { kind: 'text', text: 'Write something useful. Keep it short and honest.' }
                ]
            }
        ],
        align: 'left'
    },
    imageText: {
        image: { assetId: null, alt: '' },
        heading: 'Picture and text',
        body: [
            {
                kind: 'p',
                children: [
                    { kind: 'text', text: 'A block that pairs a single image with supporting copy.' }
                ]
            }
        ],
        imagePosition: 'left',
        cta: null
    },
    featureGrid: {
        heading: 'Features',
        body: [
            {
                kind: 'p',
                children: [
                    { kind: 'text', text: 'Three or four reasons to choose this business.' }
                ]
            }
        ],
        columns: 3,
        items: [
            { icon: 'star', title: 'Feature one', text: 'Explain what makes this useful.' },
            { icon: 'spark', title: 'Feature two', text: 'Explain what makes this useful.' },
            { icon: 'heart', title: 'Feature three', text: 'Explain what makes this useful.' }
        ]
    },
    gallery: {
        heading: 'Gallery',
        columns: 3,
        images: [
            { assetId: null, alt: '' },
            { assetId: null, alt: '' },
            { assetId: null, alt: '' }
        ]
    },
    pricing: {
        heading: 'Pricing',
        description: 'Simple, clear pricing.',
        items: [
            { name: 'Basic', price: '£20', unit: '/month', features: ['One useful thing'], highlighted: false, cta: null },
            { name: 'Standard', price: '£40', unit: '/month', features: ['Three useful things'], highlighted: true, cta: { label: 'Choose Standard', href: '#contact' } },
            { name: 'Premium', price: '£80', unit: '/month', features: ['Everything included'], highlighted: false, cta: null }
        ]
    },
    testimonials: {
        heading: 'Testimonials',
        items: [
            { quote: 'Excellent, reliable and easy to recommend.', name: 'Jamie de Garis', role: 'Local owner' },
            { quote: 'The site looks great and was live in no time.', name: 'Claire Ozanne', role: 'Studio manager' }
        ]
    },
    menuList: {
        heading: 'Menu',
        sections: [
            {
                name: 'Seasonal',
                items: [
                    { name: 'Guernsey crab on toast', description: 'With lemon and herb butter', price: '£12' },
                    { name: 'Tomato and bean soup', description: 'Served with fresh sourdough', price: '£8' }
                ]
            }
        ]
    },
    openingHours: {
        heading: 'Opening hours',
        note: 'Closed bank holidays.',
        hours: [
            { days: 'Monday – Friday', time: '09:00 – 17:00' },
            { days: 'Saturday', time: '10:00 – 14:00' },
            { days: 'Sunday', time: 'Closed' }
        ]
    },
    contact: {
        heading: 'Contact',
        body: 'Send us a message and we will get back to you.',
        buttonLabel: 'Send message'
    },
    mapAddress: {
        heading: 'Find us',
        address: '1 High Street, St Peter Port, Guernsey',
        mapUrl: 'https://maps.google.com',
        buttonLabel: 'Open in Google Maps'
    },
    stats: {
        heading: '',
        items: [
            { value: '12+', label: 'Years in business' },
            { value: '500', label: 'Happy customers' },
            { value: '4.9', label: 'Average rating' }
        ]
    },
    steps: {
        heading: 'How it works',
        body: [{ kind: 'p', children: [{ kind: 'text', text: 'Three simple steps from first hello to finished job.' }] }],
        items: [
            { title: 'Get in touch', text: 'Tell us what you need and when.' },
            { title: 'We plan it', text: 'You get a clear quote and a date.' },
            { title: 'We deliver', text: 'Sit back while we get it done.' }
        ]
    },
    quote: {
        text: 'A short, memorable line from a happy customer goes right here.',
        author: 'Alex Morgan',
        role: 'Customer'
    },
    banner: {
        text: 'Now booking for the new season.',
        cta: { label: 'Book now', href: '#contact' }
    },
    faq: {
        heading: 'Questions',
        items: [
            { question: 'How long does it take?', answer: 'Usually less than a week from first call to going live.' }
        ]
    },
    cta: {
        title: 'Ready to get started?',
        body: 'Tell us what you need and we will respond quickly.',
        cta: { label: 'Contact us', href: '#contact' },
        secondaryCta: null,
        background: 'accent'
    },
    socialLinks: {
        heading: 'Follow us',
        items: [
            { label: 'Instagram', href: 'https://instagram.com' },
            { label: 'Facebook', href: 'https://facebook.com' }
        ]
    },
    footer: {
        brand: 'Signal & Grain',
        tagline: 'Made in Guernsey.',
        links: [
            { label: 'Home', href: '#top' },
            { label: 'Contact', href: '#contact' }
        ],
        copyright: '© Signal & Grain. All rights reserved.'
    },
    spacer: {
        height: 48,
        divider: false
    },
    designed: {
        designId: 'design-01',
        texts: {},
        vars: {}
    }
};
/** Block types that can be added to a designed page (no images, no JS-dependent forms). */
export const DESIGN_EXTRA_TYPES = [
    'text',
    'featureGrid',
    'stats',
    'steps',
    'quote',
    'banner',
    'pricing',
    'testimonials',
    'menuList',
    'openingHours',
    'faq',
    'cta',
    'mapAddress',
    'socialLinks'
];
//# sourceMappingURL=blocks.js.map